import { IonButton, IonIcon } from "@ionic/react";
import { layersOutline } from "ionicons/icons";

export function PotIndicator({
  potName,
  onOpenPotSelector
}: {
  potName: string | null;
  onOpenPotSelector: () => void;
}) {
  return (
    <div className="pot-indicator">
      <span>Current pot</span>
      <PotButton potName={potName} onOpenPotSelector={onOpenPotSelector} />
    </div>
  );
}

export function PotButton({
  potName,
  onOpenPotSelector
}: {
  potName: string | null;
  onOpenPotSelector: () => void;
}) {
  return (
    <IonButton className="pot-select-button" fill="clear" size="small" aria-label="Select spending pot" onClick={onOpenPotSelector}>
      <IonIcon slot="start" icon={layersOutline} />
      <span>{potName ?? "Select pot"}</span>
    </IonButton>
  );
}
